var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 5.33334C2.66602 3.448 2.66602 2.50467 3.25202 1.91934C3.83735 1.33334 4.78068 1.33334 6.66602 1.33334H9.33268C11.218 1.33334 12.1613 1.33334 12.7467 1.91934C13.3327 2.50467 13.3327 3.448 13.3327 5.33334V10.6667C13.3327 12.552 13.3327 13.4953 12.7467 14.0807C12.1613 14.6667 11.218 14.6667 9.33268 14.6667H6.66602C4.78068 14.6667 3.83735 14.6667 3.25202 14.0807C2.66602 13.4953 2.66602 12.552 2.66602 10.6667V5.33334Z",
    stroke: "white",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2647 10.6667H5.26468C4.64468 10.6667 4.33468 10.6667 4.08002 10.7347C3.74089 10.8256 3.43168 11.0042 3.18347 11.2525C2.93526 11.5009 2.75679 11.8102 2.66602 12.1493",
    stroke: "white",
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 4.66667H10.6654M5.33203 7H8.66536",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqDark);
export default __webpack_public_path__ + "static/media/faqDark.f6f51a7e4a494aab86842296f2b15e8b.svg";
export { ForwardRef as ReactComponent };